import { NavOptionComponent } from './components/nav-option.component';
import { determineActiveRoute } from './utils/determine-active-route';
import { primaryNavOptions$ } from '../../repositories/ams/ams.repository';
import { PrimaryNavKey } from '../../models/primary-nav-key';
import { SecondaryNavComponent } from '../secondary-nav/secondary-nav.component';
import { SecondaryNavKey } from '../secondary-nav/models/secondary-nav-key';
import { AsyncPipe, NgIf } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { SubscriptionManager } from '@tmx/core';
import { distinctUntilChanged, filter, map } from 'rxjs';
import { TranslocoModule } from '@jsverse/transloco';
import { AppShellService, IconComponent } from '@tmx/modus-operandi';

@Component({
  selector: '[sideNav]',
  templateUrl: './side-nav.component.html',
  styleUrls: ['./side-nav.component.scss'],
  imports: [
    TranslocoModule,
    NgIf,
    TooltipModule,
    SecondaryNavComponent,
    NavOptionComponent,
    AsyncPipe,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SideNavComponent implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly sm = new SubscriptionManager();
  private readonly appShellService = inject(AppShellService);

  primaryNavOptions$ = primaryNavOptions$;

  PrimaryNavKey = PrimaryNavKey;
  SecondaryNavKey = SecondaryNavKey;

  sideNavOpen = this.appShellService.sideNavOpen;
  determineActiveRoute = determineActiveRoute;

  ngOnInit() {
    this.sm.manage = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        ),
        map((event) => event.url),
        distinctUntilChanged()
      )
      .subscribe((url) => {
        if (
          ['cfs', 'manage-account', 'reporting', 'diagnostics'].some(
            (segment) => url.startsWith(`/ams/${segment}`)
          )
        ) {
          this.openSideNav();
        }
      });
  }

  openSideNav() {
    this.appShellService.setSideNavOpenState(true);
  }

  ngOnDestroy() {
    this.sm.unsubscribe();
  }
}
